import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { ErrorHandleService } from './error-handle.service';

@Injectable({
  providedIn: 'root'
})

export class CityInfoEndpoint extends EndpointFactory {

  private readonly _baseUrl: string = "/api/VacantBedsInfo/";

  get baseUrl() { return this.configurations.baseUrl + this._baseUrl; }

  constructor(http: HttpClient, configurations: ConfigurationService,
    errorHandleService: ErrorHandleService, injector: Injector) {

    super(http, configurations, errorHandleService, injector);
  }
  
  getCitiesEndpoint<T>(): Observable<T> {
    let endpointUrl = `${this.baseUrl}GetCities`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.getCitiesEndpoint());
      }));
  }

  getInstitutionInfoesEndpoint<T>(cityId: number): Observable<T> {
    let endpointUrl = `${this.baseUrl}GetInstitutions/${cityId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.getInstitutionInfoesEndpoint(cityId));
      }));
  }
}
